import { parseIceServerUrl } from "../webrtc/utils/parseIceServers";

export const iceServerUpdate = (
  clientProps: { turn_server?: string },
  iceServersConfig?: RTCIceServer[],
): RTCIceServer[] => {
  if (!clientProps.turn_server || clientProps.turn_server.length === 0) {
    return iceServersConfig ?? [];
  }

  const baseStunServers: RTCIceServer[] = (iceServersConfig ?? []).filter(s => {
    const urls = Array.isArray(s.urls) ? s.urls : [s.urls];
    return urls.some(u => typeof u === "string" && /^stuns?:/i.test(u));
  });

  const uniqueTurnMap: { [key: string]: RTCIceServer } = {};

  clientProps.turn_server.split(";").forEach(raw => {
    const turn = raw.trim();
    if (!turn) return;

    // Use unified parser that supports:
    // - turns?://username:password@host:port
    // - turns?:username@password:host:port
    // - username@password:host:port
    // - turn[s]:host:port (will be skipped without creds)
    const parsed = parseIceServerUrl(turn);
    if (!parsed) return;


    const firstUrl = Array.isArray(parsed.urls) ? parsed.urls[0] : parsed.urls;
    const normalizedUrl = typeof firstUrl === "string" ? firstUrl.replace(/^turns?:/i, "turn:") : firstUrl;

    const key = `${parsed.username ?? ""}:${parsed.credential ?? ""}@${normalizedUrl}`;
    if (!uniqueTurnMap[key]) {
      uniqueTurnMap[key] = {
        urls: [typeof normalizedUrl === "string" ? normalizedUrl : ""],
        username: parsed.username,
        credential: parsed.credential,
      } as RTCIceServer;
    }
  });

  const orderedTurns = Object.values(uniqueTurnMap);

  return [...baseStunServers, ...orderedTurns];
};
